// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { hydrate } from '@/components/Parts/StarCloud/StarCloud'
import 'webrtc-adapter'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

window.STAR_SKY_USE_UPLOAD = false
window.STAR_SKY_HAS_TOUCH = false
window.addEventListener('touchstart', () => {
  window.STAR_SKY_HAS_TOUCH = true
})

hydrate()



// WEBPACK FOOTER //
// ./src/main.js